import React from 'react'
import {DefaultPlayer as Video} from 'react-html5video';
import "react-html5video/dist/styles.css";

export default function VideoPlayer(props) {
    return (
        <div className='px-5 py-[10px] md:py-[30px] flex justify-center'>
            <Video autoPlay loop muted className="hidden lg:block">
                <source src={props.video} type="video/mp4"></source>
            </Video>
            <Video className="block lg:hidden">
                <source src={props.video} type="video/mp4"></source>
            </Video>
        </div>
    );
}